import { render, staticRenderFns } from "./imgLive.vue?vue&type=template&id=c1550612&scoped=true&"
import script from "./imgLive.vue?vue&type=script&lang=js&"
export * from "./imgLive.vue?vue&type=script&lang=js&"
import style0 from "./imgLive.vue?vue&type=style&index=0&id=c1550612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1550612",
  null
  
)

export default component.exports